
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/react-init-color-scheme-script",
      function () {
        return require("private-next-pages/material-ui/react-init-color-scheme-script.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/react-init-color-scheme-script"])
      });
    }
  